import type { ExteriorColorView } from "@slfinrtl/ui-bff-routes"
import { FormProvider } from "react-hook-form"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { useCustomExteriorColor } from "./useCustomExteriorColor"
import { CustomExteriorColor } from "./view/CustomExteriorColor"
import { CustomExteriorColorSkeleton } from "./view/CustomExteriorColorSkeleton"

export interface CustomExteriorColorContainerProps {
	currentExteriorColor: ExteriorColorView | undefined
	inventoryId: string
	onExteriorColorCreated: (exteriorColor: ExteriorColorView) => void
	showCatalogExteriorColorContainer: () => void
}

export const CustomExteriorColorContainer = withErrorHandler(
	({
		currentExteriorColor,
		inventoryId,
		onExteriorColorCreated,
		showCatalogExteriorColorContainer,
	}: CustomExteriorColorContainerProps) => {
		const { form, onSubmit, props } = useCustomExteriorColor({
			currentExteriorColor,
			inventoryId,
			onExteriorColorCreated,
			showCatalogExteriorColorContainer,
		})
		return (
			<>
				<ErrorNotificationInline />
				{props ? (
					<FormProvider {...form}>
						<form onSubmit={form.handleSubmit(onSubmit)} noValidate>
							<CustomExteriorColor {...props} />
						</form>
					</FormProvider>
				) : (
					<CustomExteriorColorSkeleton />
				)}
			</>
		)
	},
)
